import { __assign } from "tslib";
export var createOOIStoreFrontBILogger = function (userId, biToken, defaults, biLogger) {
    if (defaults === void 0) { defaults = {}; }
    var defaultsWithId = __assign(__assign(__assign({}, defaults), { bi_token: biToken }), userId);
    var loggerFactory = typeof biLogger.factory === 'function' ? biLogger.factory() : biLogger;
    return loggerFactory.updateDefaults(defaultsWithId).logger();
};
//# sourceMappingURL=configure-ooi-front-bi-logger.js.map